import { TrackList } from '@/components/TrackList';
import { useScrollTop } from '@/hooks/useScrollTop';
import { StyleFilterArtistDetail } from '@/service/type/Filter';
import { useTrackLists } from '@/state/style-filter-list-store';
import React, { useRef } from 'react';
import FilterCards from './components/FilterCards';
import { MarketArtiestHeader } from './components/MarketArtiestHeader';
import PlayerCard from './components/PlayerCard';
import { Profile } from './components/Profile';
import NavBar from './NavBar';
import { useRequest } from 'ahooks';
import { getStyleFilterGroupList } from '@/service/filter';

const MobileStyleFilterArtistDetail: React.FC<{ data?: StyleFilterArtistDetail }> = ({ data }) => {
  const { marketAudioListData } = useTrackLists();
  const playerCardRef = useRef<HTMLDivElement>(null);
  const trackListRef = useRef<HTMLDivElement>(null);
  const { componentRef } = useScrollTop();

  const { data: getStyleFilterGroupData } = useRequest(getStyleFilterGroupList);

  return (
    <NavBar>
      <div ref={componentRef} className="min-h-screen">
        <MarketArtiestHeader data={data} />
        <div className="pb-6">
          <Profile playerCardRef={playerCardRef} trackListRef={trackListRef} />
        </div>
        <div className="pb-6">
          <FilterCards getStyleFilterGroupData={getStyleFilterGroupData} />
        </div>
        <div className="pb-6" ref={playerCardRef}>
          <PlayerCard />
        </div>
        <div className="px-4 py-6" ref={trackListRef}>
          <section className="p-4 bg-jen-background-primary rounded-xl overflow-hidden border border-[#202223]/10 px-6">
            <h2 className="text-[24px] text-[#48484b] tracking-[-0.96px] leading-[24px] mb-6">
              Tracks Jenerated with
              <div>
                <span>Imogen Heap </span>StyleFilters™
              </div>
            </h2>
            <TrackList trackListData={marketAudioListData['IMO-HEADLOCK']} />
          </section>
        </div>
      </div>
    </NavBar>
  );
};

export default MobileStyleFilterArtistDetail;
